import React from 'react';

/** Live checkout link, used by the checkout CTA in the price section. */
export const CHECKOUT_URL = 'https://the-young-inventor-lab.impultienda.ar/checkout';
interface CTAButtonProps {
  label: string;
  href?: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  label,
  href = '#get-access',
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[14px] bg-spark px-6 py-4 text-center text-base font-extrabold tracking-tight text-white shadow-lg shadow-spark/30 hover:bg-spark-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-spark sm:text-[17px] ${className}`} data-id="element-64" data-mp="2tykxyj56qlsi">
      {label}
    </a>;
}